export default {
    premiumFeatures: [
        {
            title: 'Mailboxansage',
            description: 'Du möchtest eine professionelle Mailboxansage? In Zukunft kannst du mit nur wenigen Klicks Deine persönliche Ansage selbständig und bequem hochladen!'
        },
        {
            title: 'Geschäftszeitenregelung',
            description: `Du möchtest Deinen Kunden die Geschäftszeiten außerhalb der Öffnungszeiten schnell und einfach kommunizieren? Dann konfiguriere Deine Abwesenheitszeiten
            und lade Deine persönliche Ansage hoch! Einfach die gewünschten Tage auswählen und die Abwesenheitszeiten festlegen. Dein Ansage wird bei eingehenden Anrufen automatisch
            im angegebenen Zeitraum abgespielt!`
        },
        {
            title: 'Hotline mit Sprachmenü',
            description: 'Du möchtest ein Sprachdialogsystem für eingehende Anrufe auf Deiner Hotline? Dann lege deine Tastenzuordnung fest und lade Deine persönliche Ansage hoch! Der Anrufer wird durch das Drücken der entsprechenden Ziffer and die jeweilig hinterlegte Zielrufnummer weitergeleitet.'
        },
        {
            title: 'Fax konfigurieren',
            description: 'Du möchtest ein FAX konfigurieren? Kein Problem! Schalte durch das UP-Grade auf  STARFACE UP einfach und schnell die FAX Funktion frei.**'
        },
        {
            title: 'Adressbuch importieren',
            description: 'Du möchtest Deine Kontakte und Adressbuch mit einem Streich auf Deine UP importieren? Dann lade Dir einfach das Template herunter! Ausfüllen, hochladen und UP-geht’s!'
        },
        {
            title: 'Tischtelefon',
            description: 'Du möchtest nicht über Apps direkt am PC, Laptop oder Smartphone telefonieren? Kein Problem! Füge Deine Tischtelefone einfach zu Deiner STARFACE UP hinzu. Du besitzt noch kein Tischtelefon? Dann bestelle Dein persönliches Wunschtelefon einfach und direkt bei uns!'
        },
    ]
};
